import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "codes-search-bar q-gutter-sm full-width" }
const _hoisted_2 = { class: "col-mb-1 resequence-container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_3158_641113)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.0818 18.5002H18.707C17.7134 18.5002 16.9005 19.3002 16.9005 20.2779V22.6482C16.9005 23.626 17.7134 24.4259 18.707 24.4259H21.0818C22.0753 24.4259 22.8882 23.626 22.8882 22.6482V20.2779C22.8882 19.3002 22.1092 18.5002 21.0818 18.5002ZM21.6839 22.6482C21.6839 22.9694 21.4082 23.2408 21.0818 23.2408H18.707C18.3805 23.2408 18.1048 22.9694 18.1048 22.6482V20.2779C18.1048 19.9568 18.3805 19.6854 18.707 19.6854H21.0818C21.4082 19.6854 21.6839 19.9568 21.6839 20.2779V22.6482ZM23.5243 7.83398H18.707C17.7097 7.83398 16.9005 8.62988 16.9005 9.61169V14.3522C16.9005 15.3337 17.7097 16.13 18.707 16.13H23.5243C24.5216 16.13 25.3307 15.3337 25.3307 14.3522V9.61169C25.3307 8.62988 24.5216 7.83398 23.5243 7.83398ZM24.1264 14.3522C24.1264 14.6782 23.8554 14.9448 23.5243 14.9448H18.707C18.3758 14.9448 18.1048 14.6782 18.1048 14.3522V9.61169C18.1048 9.28504 18.3758 9.01912 18.707 9.01912H23.5243C23.8554 9.01912 24.1264 9.28504 24.1264 9.61169V14.3522ZM14.4919 19.6854C14.3378 19.6854 14.1837 19.7432 14.0662 19.859L11.4811 22.4038V8.42655C11.4811 8.09916 11.2101 7.83398 10.8789 7.83398C10.5477 7.83398 10.2768 8.09916 10.2768 8.42655V22.4038L7.69164 19.8598C7.45642 19.6283 7.07518 19.6283 6.84033 19.8598C6.60549 20.0913 6.60512 20.4665 6.84033 20.6976L10.4533 24.253C10.6885 24.4844 11.0697 24.4844 11.3046 24.253L14.9175 20.6976C15.1528 20.4661 15.1528 20.0909 14.9175 19.8598C14.8005 19.7446 14.6462 19.6854 14.4919 19.6854Z",
    fill: "#544DC7"
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_3158_641113" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "32",
      height: "32",
      rx: "16",
      fill: "white"
    })
  ])
], -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#clip0_5084_194556)" }, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M21.0818 18.4983H18.707C17.7134 18.4983 16.9005 19.2983 16.9005 20.276V22.6463C16.9005 23.624 17.7134 24.424 18.707 24.424H21.0818C22.0753 24.424 22.8882 23.624 22.8882 22.6463V20.276C22.8882 19.2983 22.1092 18.4983 21.0818 18.4983ZM21.6839 22.6463C21.6839 22.9674 21.4082 23.2388 21.0818 23.2388H18.707C18.3805 23.2388 18.1048 22.9674 18.1048 22.6463V20.276C18.1048 19.9548 18.3805 19.6834 18.707 19.6834H21.0818C21.4082 19.6834 21.6839 19.9548 21.6839 20.276V22.6463ZM23.5243 7.83203H18.707C17.7097 7.83203 16.9005 8.62793 16.9005 9.60974V14.3503C16.9005 15.3317 17.7097 16.128 18.707 16.128H23.5243C24.5216 16.128 25.3307 15.3317 25.3307 14.3503V9.60974C25.3307 8.62793 24.5216 7.83203 23.5243 7.83203ZM24.1264 14.3503C24.1264 14.6762 23.8554 14.9429 23.5243 14.9429H18.707C18.3758 14.9429 18.1048 14.6762 18.1048 14.3503V9.60974C18.1048 9.28309 18.3758 9.01717 18.707 9.01717H23.5243C23.8554 9.01717 24.1264 9.28309 24.1264 9.60974V14.3503ZM14.4919 19.6834C14.3378 19.6834 14.1837 19.7413 14.0662 19.857L11.4811 22.4018V8.4246C11.4811 8.09721 11.2101 7.83203 10.8789 7.83203C10.5477 7.83203 10.2768 8.09721 10.2768 8.4246V22.4018L7.69164 19.8579C7.45642 19.6264 7.07518 19.6264 6.84033 19.8579C6.60549 20.0893 6.60512 20.4645 6.84033 20.6956L10.4533 24.251C10.6885 24.4825 11.0697 24.4825 11.3046 24.251L14.9175 20.6956C15.1528 20.4641 15.1528 20.089 14.9175 19.8579C14.8005 19.7427 14.6462 19.6834 14.4919 19.6834Z",
    fill: "#40484C"
  })
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "clip0_5084_194556" }, [
    /*#__PURE__*/_createElementVNode("rect", {
      width: "32",
      height: "32",
      rx: "16",
      fill: "white"
    })
  ])
], -1)
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]

import { ref} from 'vue';
import { useGrouperStore } from 'stores/grouper-store';
import { storeToRefs } from 'pinia';
import DropDown from 'components/global-common/DropDown.vue';
import SearchBar from 'components/global-common/SearchBar.vue';
import {CodeBookDropdownOptions} from 'stores/search-store';
import {useQuasar} from 'quasar';
import { Services } from 'src/services/service-manager';
import { SearchService } from 'src/services/search-service';
import { CodeType } from 'src/contracts/codeType';
import { DrgAnalysisCode } from 'src/contracts/drgAnalysis';
import { useLayoutStore } from 'stores/layout-store';
import { GrouperLayoutMode } from 'src/services/IodineGrouperService';


export default /*#__PURE__*/_defineComponent({
  __name: 'CodesSearchBar',
  setup(__props) {

const model = ref(CodeBookDropdownOptions[0]);
const grouperStore = useGrouperStore();
const {resequence} = storeToRefs(grouperStore);
const $q = useQuasar()


function changeResequencing() {
  if(!resequence.value) {
    $q.dialog({
      color: 'white',
      textColor: 'black',
      html: true,
      title: '<span class="q-dialog-custom__title">Resequencing Warning</span>',
      message: '<div class="q-dialog-custom__body">' +
          '<div style="margin-bottom: 20px">Turning on automatic resequencing will reorder any codes that have been previously moved. ' +
          'This is a sticky feature and will remain on throughout all case reviews until turned off.</div>' +
          '<div>Would you like to proceed and turn on automatic resequencing?</div>' +
          '</div>',
      ok: {
        class: 'dialog-button',
        label: 'Yes'
      },
      cancel: {
        class: 'dialog-button',
        label: 'No'
      }
    }).onOk(() => {
      grouperStore.changeResequence();
    })
  } else {
    grouperStore.changeResequence();
  }
}

function hoverResequencingText(): string {
  if (resequence.value) {
    return 'Turn off auto sequence order of diagnoses';
  }
  return 'Turn on auto sequence order of diagnoses codes';
}

function poaClick() {
  grouperStore.setAllPoaYes();
}

function searchItemSelected(code: DrgAnalysisCode) {

  if (code.codeType == 'DIAGNOSIS') {
    grouperStore.addDiagnosisCode(code.value, code.shortDescription, undefined, true);
  } else {
    grouperStore.addProcedureCode(code.value, code.shortDescription, true);
  }
}

async function search(text: string) {
  let codeType = CodeType.Diagnosis;
  if (model.value == 'Procedure, ICD-10-PCS') {
    codeType = CodeType.Procedure;
  }
  return await Services.service(SearchService).searchCodes(
    text,
    codeType
  );
}

function resultDisplay(code: DrgAnalysisCode) {
  return `${code.value} - ${code.shortDescription || code.mediumDescription}`;
}


return (_ctx: any,_cache: any) => {
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DropDown, {
      modelValue: model.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((model).value = $event)),
      options: _unref(CodeBookDropdownOptions),
      label: "Book",
      "iodine-class-name": "book"
    }, null, 8, ["modelValue", "options"]),
    _createVNode(SearchBar, {
      search: search,
      "class-name": "code",
      onItemSelected: searchItemSelected,
      "result-display": resultDisplay,
      "key-prop": "value",
      "search-on-focus": true,
      ref: "searchBarRef"
    }, null, 512),
    (_unref(useLayoutStore)().getLayoutMode == _unref(GrouperLayoutMode).fullScreen)
      ? (_openBlock(), _createBlock(_component_q_space, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_tooltip, {
        anchor: "bottom left",
        self: "center left"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(hoverResequencingText()), 1)
        ]),
        _: 1
      }),
      (_unref(resequence))
        ? (_openBlock(), _createElementBlock("svg", {
            key: 0,
            onClick: changeResequencing,
            class: "search-bar__resequencing-button search-bar__resequencing-button_enabled",
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_5))
        : (_openBlock(), _createElementBlock("svg", {
            key: 1,
            onClick: changeResequencing,
            class: "search-bar__resequencing-button search-bar__resequencing-button_disabled",
            width: "32",
            height: "32",
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }, _hoisted_8))
    ]),
    _createVNode(_component_q_btn, {
      round: "",
      unelevated: "",
      class: "io-mfe-ig-icon-button-large",
      onClick: poaClick
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_icon, { name: "fa-light fa-square-y" })
      ]),
      _: 1
    })
  ]))
}
}

})